import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import SectionHeader from '../SectionHeader/SectionHeader';
import TabItem from './TabItem';
import { headerWithDescType } from 'src/types';
import { classNames } from 'src/utils/helpers';

function HighlightTabs({ tabs, sectionHeader: { title, tagline, description } }) {
  const tabsWithID = tabs.map((tab, i) => ({
    ...tab,
    id: i,
  }));

  const [active, setActive] = useState(tabsWithID[0] || { content: {} });

  const handleNavigation = (direction) => {
    const { id: activeId } = active;
    const prevId = activeId === 0 ? tabsWithID.length - 1 : activeId - 1;
    const nextId = activeId === tabsWithID.length - 1 ? 0 : activeId + 1;
    const nextTab = tabsWithID.find((tab) => tab.id === (direction === 'prev' ? prevId : nextId));

    if (nextTab) {
      setActive(nextTab);
    }
  };

  const handleTabNavigation = (event) => {
    const nextTab = tabsWithID.find((tab) => tab.id === Number(event.target.id));

    if (nextTab) {
      setActive(nextTab);
    }
  };

  return (
    <Container as="section" className="py-5">
      <SectionHeader title={title} tagline={tagline} description={description} />

      <Container>
        <Row noGutters>
          {tabsWithID.length > 1 && (
            <Col xs={12} className="d-none d-lg-block mt-4">
              <Row className="justify-content-center align-items-center">
                {tabsWithID.map((tab) => (
                  <Col key={tab.id} xs="auto">
                    <Button
                      id={tab.id}
                      variant="link-tertiary"
                      className={classNames('`text-uppercase sm', {
                        active: tab.id === active.id,
                      })}
                      onClick={handleTabNavigation}
                    >
                      {tab.buttonLabel}
                    </Button>
                  </Col>
                ))}
              </Row>
            </Col>
          )}
          <Col xs={12} className="d-none d-lg-block mt-4">
            <TabItem
              id={active.id}
              content={active.content}
              totalTabs={tabsWithID.length}
              handleNavigation={handleNavigation}
              noNavigation={tabsWithID.length < 2}
            />
          </Col>
          <Col xs={12} className="d-lg-none">
            <Row className="flex-nowrap overflow-auto">
              {tabsWithID.map((tab) => (
                <Col key={tab.id} xs={tabsWithID.length < 2 ? 12 : 10}>
                  <TabItem id={tab.id} content={tab.content} totalTabs={tabsWithID.length} noNavigation />
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

HighlightTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      buttonLabel: PropTypes.string,
      content: PropTypes.shape({
        title: PropTypes.string,
        content: PropTypes.arrayOf(PropTypes.shape({})),
        image: PropTypes.shape({}),
        links: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    })
  ).isRequired,
  sectionHeader: headerWithDescType.propTypes,
};

HighlightTabs.defaultProps = {
  sectionHeader: headerWithDescType.defaultProps,
};

export default HighlightTabs;
